export default {
    newDesign: true,
    parameters: {
        landing_id: "InQNFw",
        segment: 4
    },
    title: "Dari Ide ke Website & Desain Digital | Kodland",
    downtimeUrl: "https://www.kodland.org/id",
    startPage: {
        title:
            "Jawab pertanyaan untuk mendaftar kelas percobaan pertama Anda.",
        subtitle: "Kami mengubah minat terhadap teknologi menjadi keuntungan:<br>💬 Temukan bakat anak Anda dengan cara yang menyenangkan<br>🌐 Hanya perlu komputer dan koneksi internet<br>💙 Lebih dari 270 anak mendaftar hanya hari ini",
        image: {
            url: "/welcome/indonesia_longquiz_fwd_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/indonesia_longquiz_fwd_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Mari kita mulai 🔥",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
        subtitle:
            "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
    },
    quizRotateBySteps: {
        1: {
            title: "Berapa usia anak Anda?",
            type: "age",
            button: "",
        },
        2: {
            question: "Apa yang paling disukai anak Anda lakukan di waktu luang?",
            answers: [
                "Olahraga atau bermain di luar ⚽",
                "Membaca buku atau komik 📚",
                "Menonton TV, YouTube, atau bermain video game 🎮",
                "Menghabiskan waktu bersama teman atau keluarga 👫",
                "Lainnya 🙂"
            ],
        },
        3: {
            question: "Bagaimana perasaan anak Anda tentang belajar online?",
            answers: [
                "Mereka menyukainya dan merasa menarik 💻",
                "Mereka lebih suka belajar tatap muka 🙂",
                "Mereka kesulitan untuk fokus 😬",
                "Belum pernah mencoba ❓"
            ],
        },
        4: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/indonesia_screen_time.png",
            subtitle: "Meskipun anak-anak disarankan untuk tidak menghabiskan lebih dari 2 jam sehari di depan layar, kenyataannya mereka biasanya melebihi waktu ini. Karena itu, idealnya hiburan dipadukan dengan aktivitas produktif, seperti pelajaran selama 1–1,5 jam.<br>Program kami dirancang dengan hal ini dalam pikiran.",
            button: "Sangat bagus ✅",
        },
        5: {
            question: "Di sekolah, apa yang paling disukai anak Anda?",
            answers: [
                "Ilmu pengetahuan atau matematika 🧪🔢",
                "Membaca dan menulis cerita 📚✍️",
                "Seni, musik, atau aktivitas kreatif 🎨🎶",
                "Pendidikan jasmani atau olahraga 🏃‍♂️⚽",
                "Lainnya 🙂"
            ],
        },
        6: {
            question: "Apakah anak Anda suka membangun atau mendesain sesuatu (misalnya dengan Lego, seni, puzzle)?",
            answers: [
                "Ya, mereka suka sekali membangun dan mendesain 🌿🏗️",
                "Kadang-kadang, tapi mereka lebih suka aktivitas lain 🤔",
                "Tidak, mereka tidak terlalu tertarik 🙇"
            ],
        },
        7: {
            question: "Bagaimana anak Anda paling baik belajar atau mengingat hal baru?",
            answers: [
                "Dengan melihat (pembelajaran visual) 👁️",
                "Dengan melakukan (pembelajaran praktis) ✋",
                "Dengan mendengar (pembelajaran auditori) 🎧",
                "Melalui pengulangan dan latihan ✏️"
            ],
        },
        8: {
            question: "Apakah anak Anda memiliki akses ke laptop atau komputer desktop untuk belajar?",
            answers: [
                "Ya, mereka punya perangkat sendiri 💻✅",
                "Ya, tapi berbagi dengan orang lain 🖥️👫",
                {
                    answer: "Tidak, tidak punya akses teratur 🚫",
                    stopAnswer: true,
                },
            ],
        },
        9: {
            question: "Jenis aktivitas atau hobi apa yang paling menarik bagi anak Anda?",
            answers: [
                "Olahraga atau menari ⚽",
                "Seni kreatif 🎨✏️",
                "Menggambar, melukis, atau kerajinan tangan 🍀♟️🖥️",
                "Video game atau menonton video 🎮🖥️",
                "Lainnya 🙂"
            ],
        },
        10: {
            question: "Bagaimana anak Anda bertindak saat bekerja dalam kelompok?",
            answers: [
                "Mereka suka berkolaborasi 🤝💡",
                "Mereka lebih suka memimpin 🧑‍🏫",
                "Mereka bekerja mandiri, tetapi tetap berkontribusi 🧍‍♂️✔️",
                "Mereka merasa malu atau tidak nyaman 😳"
            ],
        },
        11: {
            question: "Peran apa yang biasanya diambil anak Anda dalam aktivitas kelompok?",
            answers: [
                "Suka memimpin dan mengatur 🧑‍🏫📋",
                "Suka memberi ide dan berkolaborasi 🤝💡",
                "Lebih suka mendengarkan dan mengikuti 👂🙂",
                "Mencoba menengahi atau menyelesaikan konflik ⚖️🕊️",
                "Merasa malu dan tetap di belakang 😳"
            ],
        },
        12: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/indonesia_laptop.png",
            subtitle: "Kami menawarkan format pembelajaran baik individu maupun kelompok, menyesuaikan proses sesuai dengan usia setiap anak agar sepersonal mungkin.",
            button: "Mari kita mulai!",
        },
        13: {
            question: "Apakah anak Anda menunjukkan minat belajar pemrograman?",
            answers: [
                "Ya, mereka sudah mulai belajar 💻🚀",
                "Ya, mereka penasaran tetapi belum mencoba 🤔💡",
                "Belum, tapi mungkin akan tertarik 🧑‍🎓",
                "Tidak, mereka tidak tertarik 🙅"
            ],
        },
        14: {
            question: "Kapan anak Anda merasa paling nyaman dan bahagia?",
            answers: [
                "Saat bermain dengan teman atau keluarga 👫❤️",
                "Saat menjelajahi hal baru atau belajar ✨🔍",
                "Saat menciptakan atau membangun sesuatu 🛠️✨",
                "Saat memiliki waktu tenang 🤫📖"
            ],
        },
        15: {
            question: "Aktivitas atau mata pelajaran apa yang paling disukai anak Anda?",
            answers: [
                "Membaca atau menulis 📚✍️",
                "Teknologi atau komputer 💻📱",
                "Lainnya 🙂"
            ],
        },
        16: {
            question: "Apakah anak Anda suka menciptakan sesuatu atau melakukan aktivitas dengan teman?",
            answers: [
                "Ya, mereka suka proyek kreatif dalam kelompok 👫🎨",
                "Kadang-kadang, tergantung aktivitas 🤔",
                "Tidak, mereka lebih suka tugas individu 🧍💡"
            ],
        },
        17: {
            question: "Apakah anak Anda merasa nyaman menggunakan teknologi seperti komputer, aplikasi, atau tugas dasar di internet?",
            answers: [
                "Sangat nyaman, sering menggunakannya 💻✅",
                "Bisa mengerjakan tugas, tapi butuh bantuan 🖱️❓",
                "Belum terbiasa 🚫"
            ],
        },
        18: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/indonesia_before_after.png",
            subtitle: "Di Kodland, siswa merancang model 3D, membuat komik, mengembangkan game, dan belajar pemrograman. Saat ini, lebih dari 30.000 anak di seluruh dunia sedang belajar bersama kami!",
            button: "Hebat ✅",
        },
        19: {
            question: "Bagaimana anak Anda menangani tantangan atau masalah?",
            answers: [
                "Mencoba menyelesaikannya sendiri 💪🧠",
                "Meminta bantuan bila perlu 🙋‍♀️✔️",
                "Mudah frustrasi dan menyerah 😣",
                "Melihat masalah sebagai tantangan 🧑‍🏫"
            ],
        },
        20: {
            question: "Apakah anak Anda tertarik menciptakan cerita atau karakter sendiri?",
            answers: [
                "Suka bercerita dan punya ide ✍️",
                "Kadang-kadang, tapi perlu dorongan 🙂",
                "Tidak, kurang tertarik 🚫"
            ],
        },
        21: {
            question: "Bagaimana anak Anda menangani tugas yang membutuhkan perhatian dan berpikir logis?",
            answers: [
                "Fokus dan menyelesaikan masalah 🎯🍀",
                "Melakukan dengan baik jika diberi arahan 📋🤝",
                "Kesulitan dengan tugas detail 😅"
            ],
        },
        22: {
            question: "Saat anak Anda bercerita, biasanya…",
            answers: [
                "Fokus pada detail 🧵📜",
                "Langsung ke inti cerita 🎯",
                "Menambahkan humor atau imajinasi 🤹✨",
                "Kesulitan mengatur pikiran 🤔"
            ],
        },
        23: {
            question: "Bagaimana reaksi anak Anda saat mencoba sesuatu yang baru?",
            answers: [
                "Langsung bersemangat 🎉🚀",
                "Penasaran tapi hati-hati 🤔👣",
                "Gugup dan butuh dukungan 😬🙋",
                "Suka bereksperimen 🛠️🧪",
                "Enggan mencoba hal baru 🙅"
            ],
        },
        24: {
            question: "Apakah anak Anda lebih suka mengikuti instruksi atau membuat ide sendiri?",
            answers: [
                "Mereka suka instruksi yang jelas ✔️",
                "Lebih suka ide kreatif dan pendekatan baru 🎨",
                "Suka campuran struktur dan kebebasan 🛠️",
                "Tergantung tugas: struktur atau kreativitas 🤷‍♂️"
            ],
        },
        25: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/indonesia_reviews.png",
            subtitle: "Orang tua dari seluruh dunia merekomendasikan kami. Kami berharap Anda segera bergabung dengan mereka! 💙",
            button: "Hampir selesai! ✅",
        },
        26: {
            question: "Apa yang memotivasi anak Anda untuk tetap fokus pada sebuah tugas?",
            answers: [
                "Tujuan yang jelas atau hadiah di akhir 🎯🏅",
                "Rasa antusias atau semangat terhadap tugas ✨❤️",
                "Bekerja dalam kelompok 🤝💬",
                "Mendapatkan motivasi selama proses 👏🙂",
                "Merasa itu adalah tantangan atau kompetisi 🏅🔥"
            ],
        },
        27: {
            question: "Jenis cerita atau topik apa yang paling disukai anak Anda untuk dibicarakan?",
            answers: [
                "Sains, teknologi, atau penemuan 🧪🛠️",
                "Sains, teknologi, atau penemuan baru 🧬💻",
                "Cerita lucu atau komik 🤪😂",
                "Peristiwa nyata atau sejarah 📜🌍",
                "Cerita tentang persahabatan atau emosi ❤️👫"
            ],
        },
        28: {
            question: "Apa yang membuat anak Anda merasa bangga atau puas?",
            answers: [
                "Menyelesaikan tugas menantang 🏆🧠",
                "Membantu orang lain atau berkontribusi 🤝❤️",
                "Belajar sesuatu yang baru 📚✨",
                "Mendapatkan umpan balik positif 🥳👏",
                "Menyelesaikan masalah rumit 🔍🍀"
            ],
        },
        29: {
            title: "🎉 Tinggal satu langkah lagi!",
            typeInfo: "congrats",
            subtitle:
                "Bantu anak Anda menjelajahi sisi kreatifnya melalui pemrograman dan desain digital.<br>🌟 Lebih dari 200.000 anak sudah belajar dan berkarya bersama kami.",
            button: "📅 Pesan kelas gratis sekarang!",
        },
        30: {
            title: "🎉 Daftar kelas percobaan gratis",
            type: "one-page-contacts",
            subtitle: "Di pelajaran pertama, anak Anda akan membuat mini-game — dan Anda juga bisa ikut!",
            button: "✨ Sempurna! Tinggal satu langkah lagi.",
        },
        31: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        32: {
            title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
            button: "Selanjutnya bagaimana?",
        },
        33: {
            title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
            button: "Selanjutnya bagaimana?",
        },
        34: {
            title: "Kelas akan diadakan di platform kami 💻",
            typeInfo: "classroom",
            subtitle:
              "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
            button: "Mengerti ✅",
        },
    },
};
